import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './layouts/DashboardLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './services/auth';
import Users from './pages/Users';
import Companies from './pages/Companies';
import NotFound from './pages/NotFound';
import UserForm from './pages/UserForm';
import CompanyForm from './pages/CompanyForm';
import BethaData from './pages/BethaData';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="usuarios" element={<Users />} />
          <Route path="usuarios/novo" element={<UserForm />} />
          <Route path="usuarios/editar/:username" element={<UserForm />} />
          <Route path="empresas" element={<Companies />} />
          <Route path="empresas/novo" element={<CompanyForm />} />
          <Route path="empresas/editar/:cnpj" element={<CompanyForm />} />
          <Route path="dados" element={<BethaData />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
